import { getReportPageStore } from './store';

export function getColumnMembers() {
  return getReportPageStore().columnMembers;
}

export function getReportType() {
  return getReportPageStore().reportType;
}
